import React, { Component } from "react";
import PropTypes from "prop-types";
import { base } from "../base.js";
import { CSSTransitionGroup } from "react-transition-group";
import { Loader } from "react-loaders";
import "./Board.css";
import smoothscroll from "smoothscroll-polyfill";
import Header from "./Header.js";
import ConcernListItem from "./ConcernListItem.js";
import CompletedConcerns from "./CompletedConcerns.js";
import FinishButton from "./FinishButton.js";
import NewKudos from "./NewKudos.js";
import NewConcern from "./NewConcern.js";
import Modal from "./Modal.js";
import AddAction from "./AddAction.js";
import Coachmarks from "./Coachmarks.js";
import concernIllustration from "../concern-illustration.svg";

class Board extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      concerns: [],
      showActionModal: false,
      concernIndex: -1,
      concernsLoaded: false,
    };
  }

  componentWillMount = () => {
    base.syncState(`${this.props.user.uid}/concerns/`, {
      context: this,
      state: "concerns",
      asArray: true,
      then() {
        this.setState({
          concernsLoaded: true,
        });
      },
    });
  };

  componentDidMount = () => {
    //Provides smooth scrolling support for Safari and other browsers
    smoothscroll.polyfill();
  };

  commitNewConcern = (newConcern, newReporter) => {
    var concerns = [...this.state.concerns];
    var currentDate = Date.now();

    concerns.unshift({
      id: currentDate,
      concernText: newConcern,
      reporter: newReporter,
      action: null,
      plusOnes: 1,
      createdAt: currentDate,
      status: "open",
      userId: this.props.user.uid,
    });

    this.setState({
      concerns: concerns,
    });

    // Increments the concernsAdded count of currentRetroSession by 1
    this.props.commitUpdatedKudosConcernsCount("concernsAdded");

    this.scrollToTop("smooth");

    window.analytics.track("Adds New Concern", {
      concernText: newConcern,
      reporter: newReporter,
    });
  };

  commitEditedConcern = (index, fieldName, updatedField) => {
    var concerns = [...this.state.concerns];
    var concern = concerns[index];
    concern[fieldName] = updatedField;

    this.setState({
      concerns: concerns,
    });
  };

  updateConcernStatus = (index, newStatus, oldStatus) => {
    var concerns = [...this.state.concerns];
    var concern = concerns[index];
    concern.status = newStatus;

    if (oldStatus === "completed") {
      concerns.splice(index, 1);
      concerns.push(concern);

      window.analytics.track("Uncompletes a Concern", {
        concernText: concern.concernText,
        reporter: concern.reporter,
        plusOnesCount: concern.plusOnes,
        actionMemberId: concern.action ? concern.action.memberId : null,
        actionText: concern.action ? concern.action.actionText : null,
      });
    } else if (oldStatus === "queued") {
      window.analytics.track("Unqueues a Concern", {
        concernText: concern.concernText,
        reporter: concern.reporter,
        plusOnesCount: concern.plusOnes,
        actionMemberId: concern.action ? concern.action.memberId : null,
        actionText: concern.action ? concern.action.actionText : null,
      });
    } else if (oldStatus === "open") {
      window.analytics.track("Queues a Concern", {
        concernText: concern.concernText,
        reporter: concern.reporter,
        plusOnesCount: concern.plusOnes,
        actionMemberId: concern.action ? concern.action.memberId : null,
        actionText: concern.action ? concern.action.actionText : null,
      });
    }

    this.setState({
      concerns: concerns,
    });
  };

  incrementPlusOnes = index => {
    var concerns = [...this.state.concerns];
    var concern = concerns[index];
    concern.plusOnes = concern.plusOnes + 1;

    this.setState({
      concerns: concerns,
    });

    window.analytics.track("Upvotes a Concern", {
      concernText: concern.concernText,
      reporter: concern.reporter,
      plusOnesCount: concern.plusOnes,
      actionMemberId: concern.action ? concern.action.memberId : null,
      actionText: concern.action ? concern.action.actionText : null,
    });
  };

  openCloseActionModal = (bool, index) => {
    this.setState({
      showActionModal: bool,
      concernIndex: index,
    });
  };

  scrollToTop = behavior => {
    this.topOfConcerns.scrollIntoView({ behavior: behavior });
  };

  scrollToBottom = behavior => {
    this.bottomOfConcerns.scrollIntoView({ behavior: behavior });
  };

  sortConcernsByRecency = (obj1, obj2) => {
    if (obj1.createdAt > obj2.createdAt) {
      return -1;
    } else if (obj1.createdAt < obj2.createdAt) {
      return 1;
    } else {
      return 0;
    }
  };

  //NOTE: This function currently is a copy of a function inside ExpireRetro.js
  finishRetro = sendEmails => {
    const concerns = [...this.state.concerns];
    var concernsCompleted = 0;
    var totalConcernsCompleted = 0;

    // Counts queued concerns and then marks them as completed
    concerns.forEach(concern => {
      if (concern.status === "queued") {
        concernsCompleted = concernsCompleted + 1;
        totalConcernsCompleted = totalConcernsCompleted + 1;
        concern.status = "completed";
      } else if (concern.status === "completed") {
        totalConcernsCompleted = totalConcernsCompleted + 1;
      }
    });

    concerns.sort(this.sortConcernsByRecency);

    this.setState({
      concerns: concerns,
    });

    this.props.commitFinishedRetro(
      concernsCompleted,
      totalConcernsCompleted,
      sendEmails
    );
  };

  countUncompletedConcerns = () => {
    let count = 0;
    this.state.concerns.forEach(concern => {
      if (concern.status === "open" || concern.status === "queued") {
        count++;
      }
    });

    return count;
  };

  renderConcernsOrZeroState = () => {
    if (this.countUncompletedConcerns() > 0) {
      return (
        <div className="concerns-list">
          <CSSTransitionGroup
            component="ul"
            transitionName="concern-transition"
            transitionAppear={true}
            transitionAppearTimeout={300}
            transitionEnterTimeout={300}
            transitionLeaveTimeout={0}
          >
            {this.state.concerns.map(
              (concern, index) =>
                concern.status === "open" || concern.status === "queued" ? (
                  <ConcernListItem
                    concern={concern}
                    key={concern.id}
                    members={this.props.members}
                    index={index}
                    updateConcernStatus={this.updateConcernStatus}
                    commitEditedConcern={this.commitEditedConcern}
                    incrementPlusOnes={this.incrementPlusOnes}
                    openCloseActionModal={this.openCloseActionModal}
                  />
                ) : null
            )}
          </CSSTransitionGroup>
        </div>
      );
    } else {
      return (
        <div className="zero-state-container">
          <div className="header">
            <h1>Welcome! The team discussion starts... now.</h1>
          </div>
          <div className="grey-sun">
            <img
              src={concernIllustration}
              alt="concern-illustration"
              className="concern-illustration"
            />
            <img
              src={concernIllustration}
              alt="concern-illustration"
              className="concern-illustration"
            />
            <img
              src={concernIllustration}
              alt="concern-illustration"
              className="concern-illustration"
            />
          </div>
        </div>
      );
    }
  };

  render() {
    const contentContainer = (
      <div className="content-container">
        {this.renderConcernsOrZeroState()}
        <CompletedConcerns
          concerns={this.state.concerns}
          updateConcernStatus={this.updateConcernStatus}
          members={this.props.members}
        />
        <div ref={div => (this.bottomOfConcerns = div)} />
        <div className="action-bar">
          <Coachmarks
            concernsLength={this.state.concerns.length}
            kudosGiven={this.props.kudosGiven}
            retroSessionsCount={this.props.retroSessionsCount}
          />
          <NewKudos
            kudosGiven={this.props.kudosGiven}
            commitUpdatedKudosConcernsCount={
              this.props.commitUpdatedKudosConcernsCount
            }
          />
          <NewConcern commitNewConcern={this.commitNewConcern} />
          <FinishButton
            finishRetro={this.finishRetro}
            deleteRetro={this.props.deleteRetro}
            scrollToBottom={this.scrollToBottom}
          />
        </div>
      </div>
    );

    return (
      <div>
        <div ref={div => (this.topOfConcerns = div)} />
        <Modal
          showActionModal={this.state.showActionModal}
          openCloseActionModal={this.openCloseActionModal}
        >
          <AddAction
            openCloseActionModal={this.openCloseActionModal}
            members={this.props.members}
            commitNewMember={this.props.commitNewMember}
            concernIndex={this.state.concernIndex}
            concern={this.state.concerns[this.state.concernIndex]}
            commitEditedConcern={this.commitEditedConcern}
          />
        </Modal>
        <Header
          user={this.props.user}
          freeRetros={this.props.freeRetros}
          payment={this.props.payment}
        />
        <div className="board-container">
          {this.state.concernsLoaded ? (
            contentContainer
          ) : (
            <div className="loader-container">
              <Loader type="line-scale" active />
            </div>
          )}
        </div>
      </div>
    );
  }
}

Board.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    uid: PropTypes.string.isRequired,
    creationTime: PropTypes.string.isRequired,
    lastSignInTime: PropTypes.string.isRequired,
    photoURL: PropTypes.string,
  }).isRequired,
  members: PropTypes.array,
  commitFinishedRetro: PropTypes.func.isRequired,
  deleteRetro: PropTypes.func.isRequired,
  commitNewMember: PropTypes.func.isRequired,
  kudosGiven: PropTypes.number.isRequired,
  commitUpdatedKudosConcernsCount: PropTypes.func.isRequired,
  freeRetros: PropTypes.number.isRequired,
  payment: PropTypes.shape({
    activeSubscription: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    stripeCustomerID: PropTypes.string.isRequired,
  }),
  retroSessionsCount: PropTypes.number.isRequired,
};

export default Board;



// WEBPACK FOOTER //
// ./src/components/Board.js